import './About.css';
import { faStar } from '@fortawesome/free-solid-svg-icons';
import { faEye } from '@fortawesome/free-solid-svg-icons';
import { faBullseye } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

function About() {
  return (
    <div id="about">
        <div className="about-container">
            <h1>About Solid Investment</h1>
            <p className='about-subtitle'>Who We Are</p>
            <p><b>Solid Investment</b> is a forward-thinking investment company focused on identifying, scaling, and transforming high-potential brands into globally recognized ventures. With a core specialization in <b>brand growth</b> and <b>international expansion</b>, we bring strategic insight, operational excellence, and collaborative partnerships to every project we back.</p>
            <p>In addition to our active work in brand development, we are expanding our horizons into new verticals. Our upcoming <b>real estate venture</b> marks our first step into lifestyle-oriented developments, while we also explore opportunities in <b>creative ecosystems</b> and <b>intelligent technologies</b>, sectors we believe will shape the future of investment and consumer behavior.</p>
            <p>Our approach is grounded in <b>innovation</b>, <b>agility</b>, and <b>strategic alignment</b>, unlocking long-term value while opening doors to regional and global opportunities.</p>
            <div className="about-more">
                <div className="about-vision">
                    <FontAwesomeIcon icon={faEye} className="about-icon" />
                    <h2>Vision</h2>
                    <p>To lead in identifying and scaling high-potential ventures across multiple industries, creating lasting value and global impact through strategic investment and innovation.</p>
                </div>
                <div className="about-mission">
                    <FontAwesomeIcon icon={faBullseye} className="about-icon" />
                    <h2>Mission</h2>
                    <p>To invest in and grow scalable concepts by applying operational excellence, market expertise, and collaborative partnerships—starting with brands and expanding into new, forward-looking sectors.</p>
                </div>
                <div className="about-core-values">
                    <FontAwesomeIcon icon={faStar} className="about-icon" />
                    <h2>Core Values</h2>
                    <p>We value innovation, integrity, and excellence. Our decisions are driven by strategic thinking, transparency, and sustainable growth, with a deep belief in partnerships that create shared, long-term success.</p>
                </div>
            </div>
        </div>
    </div>
  );
}

export default About;
